type Clock={monotonic:()=>number;wall:()=>number};
/** Presentation only; the SQL deadline is authoritative. Initial device clock
 * error cancels out, elapsed wall time covers platforms that pause performance
 * while asleep, and backwards clock changes never reopen a hidden window. */
export function anchorRestoreClock(serverTime:string,clock:Clock={monotonic:()=>performance.now(),wall:()=>Date.now()}):()=>number{
 const epoch=Date.parse(serverTime),mono=clock.monotonic(),wall=clock.wall();let elapsed=0;
 if(!Number.isFinite(epoch)||!Number.isFinite(mono)||!Number.isFinite(wall))throw new Error('Время сервера недоступно');
 return()=>{elapsed=Math.max(elapsed,0,clock.monotonic()-mono,clock.wall()-wall);return epoch+elapsed;};
}
export function restoreTimeLeft(until:unknown,now:number):number{
 if(typeof until!=='string'||!Number.isFinite(now))return 0;
 const deadline=Date.parse(until);return Number.isFinite(deadline)?Math.max(0,deadline-now):0;
}
